import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ImageService } from "../../core";

@Component({
  selector: "app-preview-image",
  templateUrl: "./preview-image.component.html",
  styleUrls: ["./preview-image.component.css"]
})
export class PreviewImageComponent implements OnInit {
  imageSrc: string = "";
  defaultImageSrc: string = "assets/img/defaultImage.png";

  constructor(
    private route: ActivatedRoute,
    private imageService: ImageService
  ) {}

  ngOnInit() {
    this.setUpImageId();
  }

  setUpImageId() {
    const imageId = this.route.snapshot.params["id"];
    if (imageId && Number(imageId)) {
      this.imageSrc = this.getMediumImg(imageId);
    }
  }

  getMediumImg(id: any) {
    return this.imageService.mediumLargeThumbnail(id);
  }
}
